export const ethApikey = "B8KJQHWZH698BSGDSA4H2TIUJ1XMPXN1UA";
export const bscApikey = "YC8CC114NC8IYNVP39SJJKCC4CQ4DZW8Q6";
